import tokenService from '@/services/tokenService';
import { ApiAuth } from './types/IRootState';

const auth: ApiAuth = {
    isLogged: false,
    token: null,
    user: null,
};

const token = tokenService.getToken();

if (token) {
    auth.isLogged = true;
    auth.token = token;
}

export default auth;
